import {Input} from "@material-tailwind/react/components/Input";
import React, {HTMLInputTypeAttribute, memo} from "react";

interface MTInputProps {
    label: string,
    placeholder?: string,
    name: string,
    type: HTMLInputTypeAttribute,
    onChange?: (key: string, value: string | number) => void,
    onBlur?: (key: string) => void,
    onFocus?: (key: string) => void,
    icon?: JSX.Element,
    value?: string | number,
    className?: string
}


const MTInput = React.forwardRef(({
                                      placeholder,
                                      name,
                                      label,
                                      type,
                                      onChange,
                                      onBlur,
                                      onFocus,
                                      icon,
                                      value,
                                      className
                                  }: MTInputProps) => {

    const onLocalChange = (e: React.ChangeEvent<HTMLInputElement> | undefined) => {
        if (onChange && e?.currentTarget) {
            onChange(name, e.currentTarget.value);
        }
    }

    const onLocalBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        if (onBlur && e.type === 'blur') {
            onBlur(name);
        }
    }

    const onLocalFocus = (e: React.FocusEvent<HTMLInputElement>) => {
        if (onFocus && e.type === 'focus') {
            onFocus(name);
        }
    }

    return (
        <Input icon={icon ?? null} type={type}
               onChange={onLocalChange}
               onBlur={onLocalBlur}
               onFocus={onLocalFocus}
               defaultValue=""
               autoComplete="one-time-code"
               crossOrigin={'anonymous'} name={name} variant={"outlined"} label={label} placeholder={placeholder}
               value={value ?? ''}
               className={`inline-block dark:text-gray-500 dark:border-blue-gray-800 dark:placeholder-shown:border-blue-gray-800 dark:focus:border-blue-gray-800 dark:focus:border-t-transparent dark:placeholder-shown:border-t-transparent ${className ?? ''}`}
               labelProps={{className: "dark:after:border-blue-gray-800 dark:before:border-blue-gray-800 dark:peer-focus:text-white dark:peer-focus:before:!border-blue-gray-800 dark:peer-focus:after:!border-blue-gray-800"}}
        />
    );

});

MTInput.displayName = 'MTInput';

export default memo(MTInput);
